import {printoutTheme} from "./printoutTheme";

// Semantic aliases for the fixed print theme; these colors must not follow the app theme.
export const printoutPalette = {
    primaryText: printoutTheme.ink.strong,
    secondaryText: printoutTheme.ink.body,
    mutedText: printoutTheme.ink.muted,
    border: printoutTheme.rule.default,
    subtleBorder: printoutTheme.rule.light,
    strongBorder: printoutTheme.rule.strong,
    subtleFill: printoutTheme.fill.band,
    paper: printoutTheme.fill.paper,
} as const;
